/* unplugin-vue-components disabled */import { render } from "./JsonXml.vue?vue&type=template&id=a5cd6aec&scoped=true"
import script from "./JsonXml.vue?vue&type=script&lang=js"
export * from "./JsonXml.vue?vue&type=script&lang=js"

import "./JsonXml.vue?vue&type=style&index=0&id=a5cd6aec&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5cd6aec"]])

export default __exports__